import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';


import Pagination from '../../helpers/Pagination';


const AccessHistory = ({UserServices,AuthService}) => {
    const { t } = useTranslation();

   const userId = AuthService.getCustom("user_id");

   const [isLoading, setIsLoading] = useState(true);
   const [loginHistory, setLoginHistory] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const [totalPages, setTotalPages] = useState(1);


   const loadLoginHistory = async (page = 1) => {
      setIsLoading(true);
      try {
          const data = await UserServices.getLoginHistory(userId, 10, page);
        
            if (data.status == "ok" && data.params.count > 0) {
                data.params.logins = data.params.logins.map(login => ({
                ...login,
                ip: login.ip.split(',')[0]
                }));

              setLoginHistory(data.params.logins || []);
              setTotalPages(data.params.total_pages || 1);
          } else {
              setLoginHistory([]);
              setTotalPages(1); 
          }
      } catch (error) {
          console.error("Error fetching login history:", error);
          setLoginHistory([]);
          setTotalPages(1);
      } finally {
          setIsLoading(false);
      }
  };

   useEffect(() => {
      loadLoginHistory(currentPage);
   }, [currentPage]);

   const handlePageChange = (page) => {
      if (page >= 1 && page <= totalPages) {
         setCurrentPage(page);
      }
   };

   



  return (
   <div className="form-online">
       <section className="forms boxed-form">
           <div className="form signup">
               <div className="form-content">
                   <div className="header-form-content">
                   <h3>{t('Access')}</h3>
                   </div>
                   {isLoading ? (
                        <div className="content-loader-games">
                            {t('loading')}...
                            <div className="loader-games"></div>
                        </div>
                    ) : (
                   <div className="responsive-table__upper-element right-shadow access">
                       <div className="responsive-table__left-shadow-el"></div>
                       <div className="responsive-table__wrapper">
                           <div className="responsive-table">
                               <div className="responsive-table__cell responsive-table__header sticky-header-and-first-col">{t('Date')}</div>
                               <div className="responsive-table__cell responsive-table__header">{t('Browser')}</div>
                                    <div className="responsive-table__cell responsive-table__header responsive-table__cell--last-of-row">{t('IP')}</div>

                                    
                                        {loginHistory.length > 0 && loginHistory.map((entry, index) => (
                                       <React.Fragment key={entry.id}>
                                           <div className={`responsive-table__cell sticky-cell ${index % 2 === 1 ? 'responsive-table__cell--striped' : ''}`}>
                                                    {new Date(entry.last_login_date * 1000).toLocaleString()}
                                           </div>
                                           <div className={`responsive-table__cell ${index % 2 === 1 ? 'responsive-table__cell--striped' : ''}`}>
                                               {entry.user_browser}
                                           </div>
                                                <div className={`responsive-table__cell responsive-table__cell--last-of-row ${index % 2 === 1 ? 'responsive-table__cell--striped' : ''}`}>
                                               {entry.ip}
                                           </div>
                                       </React.Fragment>
                                        ))}
                           </div>
                       </div>
                   </div>
                    )}

                   {loginHistory.length === 0 && !isLoading && (
                       <div className="no-content-search">
                           <p>{t('No_access_history_found.')}</p>
                       </div>
                   )}

                   <div className="pagination_list_element">
                   <ul className="pagination">
                                            {/* Previous Page */}
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <a className="page-link"  onClick={() => handlePageChange(currentPage - 1)} aria-label="Previous">
                                                    <span aria-hidden="true">«</span>
                                                </a>
                                            </li>

                                            {/* Dynamic Page Buttons */}
                                            <Pagination 
                                             currentPage={currentPage} 
                                             totalPages={totalPages} 
                                             handlePageChange={handlePageChange} 
                                          />

                                            {/* Next Page */}
                                            <li className={`page-item ${currentPage === totalPages.length ? 'disabled' : ''}`}>
                                                <a className="page-link"  onClick={() => handlePageChange(currentPage + 1)} aria-label="Next">
                                                    <span aria-hidden="true">»</span>
                                                </a>
                                            </li>
                                        </ul>
                   </div>
               </div>
           </div>
       </section>
   </div>
);
};

export default AccessHistory;


